import React from "react";

function Project() {
    return (
        <div className="pagecontainer home">
            <div className="homeimg">
                Project
            </div>
        </div>
    );
}

export default Project;